var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6562",
  d: "M20.707 9.996A8.496 8.496 0 0 0 12.21 1.5a8.496 8.496 0 0 0-6.65 13.783l.023.028q.096.118.194.233l5.529 6.64c.166.2.412.316.672.316h.467c.26 0 .506-.116.672-.315l5.503-6.61q.122-.14.237-.285l.006-.007a8.46 8.46 0 0 0 1.846-5.287h-.001Zm-8.497 3.999a3.664 3.664 0 1 1-.001-7.328 3.664 3.664 0 0 1 .001 7.328"
})));
export default SvgDelivery;